import { ILocalStorageRepository } from "Infrastructure/interfaces/ILocalStorageRepository";
import { IWalletRechargeModel } from "modules/payment/domain/models/IWalletTransaction";
import { getGlobalAddLog } from "../appInsights/AppInsights";
import { LocalStorageRepository } from "./_LocalStorageRepository";
import { ILocalStorageWalletRepository } from "../../../domains/order/interfaces/repositories/ILocalStorageWalletRepository";

const KEY = "@meep/Wallet";

const addLog = getGlobalAddLog();
const localStorageRepository: ILocalStorageRepository =
  LocalStorageRepository();

export const LocalStorageWalletRepository =
  (): ILocalStorageWalletRepository => {
    const getPendentWalletRecharge = async (): Promise<
      IWalletRechargeModel[]
    > => {
      const storagePedidosPOS: IWalletRechargeModel[] =
        (await localStorageRepository.get<IWalletRechargeModel[]>(KEY)) ?? [];
      addLog &&
        addLog("WalletRepository", {
          message: "pendentRecharges",
          storagePedidosPOS,
        });
      return storagePedidosPOS;
    };

    const savePendentConfirmationWalletRechargeOrders = async (
      pedidosRecargaWallet: IWalletRechargeModel[]
    ) => {
      const storagePedidosWallet: IWalletRechargeModel[] =
        (await localStorageRepository.get<IWalletRechargeModel[]>(KEY)) ?? [];

      addLog &&
        addLog("WalletRepository", {
          message: "addPendentRecharges",
          pedidosRecargaWallet,
        });

      const newPendentOrder = [
        ...storagePedidosWallet,
        ...pedidosRecargaWallet,
      ];
      localStorageRepository.post(KEY, newPendentOrder);
    };

    const removeWalletPendingRechargeFromStorageQueueAsync = async (
      id: string
    ) => {
      const storageWalletRecharges = await localStorageRepository.get<
        IWalletRechargeModel[]
      >(KEY);
      const newRechargeWalletList =
        storageWalletRecharges?.filter((it) => it.orderId !== id) ?? [];
      await localStorageRepository.post(KEY, newRechargeWalletList);

      addLog &&
        addLog("WalletRepository", {
          message: "removePendentRecharge",
          id,
        });

      return newRechargeWalletList;
    };

    return {
      getPendentWalletRecharge,
      savePendentConfirmationWalletRechargeOrders,
      removeWalletPendingRechargeFromStorageQueueAsync,
    };
  };
